var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isVisible,
            expression: "isVisible"
          }
        ],
        staticClass: "cyt-availability-notification",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submit($event)
          }
        }
      },
      [
        _vm._t("before"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "input input-unit",
            attrs: { "data-validate": "mail" }
          },
          [
            _c("label", { attrs: { for: "mail_" + _vm._uid } }, [
              _vm._v(
                _vm._s(
                  _vm.$translate(
                    "cytItemAvailabilityNotification::Template.mailInputLabel"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.mailValue,
                  expression: "mailValue"
                }
              ],
              attrs: {
                type: "email",
                autocomplete: "email",
                id: "mail_" + _vm._uid,
                disabled: _vm.isLoading
              },
              domProps: { value: _vm.mailValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.mailValue = $event.target.value
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasPrivacyHint && _vm.requirePrivacyCheck,
                expression: "hasPrivacyHint && requirePrivacyCheck"
              }
            ],
            staticClass: "form-check small mb-3"
          },
          [
            _c("input", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.requirePrivacyCheck,
                  expression: "requirePrivacyCheck"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.privacyAccepted,
                  expression: "privacyAccepted"
                }
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "cyt_privacy_check_" + _vm._uid },
              domProps: {
                checked: Array.isArray(_vm.privacyAccepted)
                  ? _vm._i(_vm.privacyAccepted, null) > -1
                  : _vm.privacyAccepted
              },
              on: {
                change: function($event) {
                  var $$a = _vm.privacyAccepted,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.privacyAccepted = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.privacyAccepted = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.privacyAccepted = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "cyt_privacy_check_" + _vm._uid }
              },
              [_vm._t("privacyhint")],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasPrivacyHint && !_vm.requirePrivacyCheck,
                expression: "hasPrivacyHint && !requirePrivacyCheck"
              }
            ],
            staticClass: "privacy-hint small mb-3"
          },
          [_vm._t("privacyhint")],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-appearance",
            attrs: { type: "submit", disabled: _vm.submitDisabled }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$translate(
                    "cytItemAvailabilityNotification::Template.submitLabel"
                  )
                ) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _vm._t("after")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }